
import React from 'react';
import './SoWPage.css';

import SoWHeroSection from '../../components/SoWPage/SoWHeroSection/SoWHeroSection';
import SoWByPersonaSection from '../../components/SoWPage/SoWByPersonaSection/SoWByPersonaSection';
import SupportModelSection from '../../components/SoWPage/SupportModelSection/SupportModelSection';
import SoWCtaSection from '../../components/SoWPage/SoWCtaSection/SoWCtaSection'; 

export default function SoWPage() {
  return (
    <div className="sow-page-wrapper">
      <SoWHeroSection />
      <SoWByPersonaSection />
      <SupportModelSection />
      <SoWCtaSection />
    
    </div>
  );
}